import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as segueDashboardRoutes } from './segueDashboard/segueDashboard.routes';
import { routes as horarioUsoRoutes } from './horarioUso/horarioUso.routes';
import { routes as controleAcessoRoutes } from './controleAcesso/controleAcesso.routes';
import { routes as kanbanRoutes } from './kanban/kanban.routes';
import { routes as metaRoutes } from './meta/meta.routes';
// v106: Simulador pelo menu + Ranking de vendas
import { routes as simuladorRoutes } from './simulador/simulador.routes';
import { routes as simulacaoDigitacaoRoutes } from './simulacaoDigitacao/simulacaoDigitacao.routes';
import { routes as propostasRoutes } from './propostas/propostas.routes';
import { routes as rankingRoutes } from './ranking/ranking.routes';
// v109: WhatsApp Call (Dashboard + Configuração)
import { routes as whatsappCallRoutes } from './whatsappCall/whatsappCall.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...segueDashboardRoutes,
        ...horarioUsoRoutes,
        ...controleAcessoRoutes,
        ...captainRoutes,
        ...kanbanRoutes,
        ...metaRoutes,
        ...simuladorRoutes,
        ...simulacaoDigitacaoRoutes,
        ...propostasRoutes,
        ...rankingRoutes,
        ...whatsappCallRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...campaignsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'supervisor', 'agent', 'operacional', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
